module.exports = require('./lib/linkify-string').default;



//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/~/linkifyjs/string.js
// module id = ../../../../linkifyjs/string.js
// module chunks = 4